/* Bait Dogs - cart drawer behaviour. Ported from design-reference/site.js (cart),
   wired to the real Shopify AJAX Cart API. Renders line items from /cart.js so
   quick-add and qty changes update live, with the free-shipping progress bar. */
(function () {
  "use strict";

  var FREE_SHIP = 6000; // cents - matches "Free US shipping over $60"
  var ESTIMATED_SHIPPING = 500; // cents - standard US shipping shown before checkout
  var drawer = document.getElementById("bd-cart");
  var shippingUnlocked = false;
  var shippingCelebrationPending = false;
  var shippingCelebrationTimer;

  function celebrateShipping() {
    if (!drawer || !drawer.classList.contains("open") || !shippingCelebrationPending || !shippingUnlocked) return;
    shippingCelebrationPending = false;
    var reward = drawer.querySelector(".cart__ship");
    if (!reward || (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches)) return;
    clearTimeout(shippingCelebrationTimer);
    reward.classList.add("is-celebrating");
    shippingCelebrationTimer = setTimeout(function () { reward.classList.remove("is-celebrating"); }, 1400);
  }

  function r(path, fallback) { return (window.routes && window.routes[path]) || fallback; }
  function money(cents) { return "$" + (cents / 100).toFixed(2); }
  function lock(on) { document.body.style.overflow = on ? "hidden" : ""; }
  function openCart() { if (drawer) { drawer.classList.add("open"); drawer.setAttribute("aria-hidden", "false"); lock(true); celebrateShipping(); } }
  function closeCart() { if (drawer) { drawer.classList.remove("open"); drawer.setAttribute("aria-hidden", "true"); lock(false); } }
  function setText(sel, txt) { var e = document.querySelector(sel); if (e) e.textContent = txt; }

  document.addEventListener("cart:refresh", function (event) {
    if (!event.detail) return;
    render(event.detail);
    openCart();
  });

  function render(cart) {
    var wrap = document.querySelector("[data-cart-items]");
    if (wrap) {
      if (!cart.items || !cart.items.length) {
        wrap.innerHTML = '<div class="cart__empty"><p>Your cart is empty.<br>Time to bite back.</p></div>';
      } else {
        wrap.innerHTML = cart.items.map(function (l) {
          var opts = (l.variant_title && l.variant_title !== "Default Title") ? l.variant_title : "";
          var img = l.image ? '<img src="' + l.image + '" alt="" loading="lazy">' : "";
          return '<div class="citem">' +
            '<div class="citem__img">' + img + "</div>" +
            '<div style="flex:1">' +
              '<div class="citem__name">' + l.product_title + "</div>" +
              (opts ? '<div class="citem__opt">' + opts + "</div>" : "") +
              '<div class="citem__row">' +
                '<div class="qty">' +
                  '<button type="button" data-qty="' + l.key + "|" + (l.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
                  "<span>" + l.quantity + "</span>" +
                  '<button type="button" data-qty="' + l.key + "|" + (l.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
                "</div>" +
                '<span class="citem__price">' + money(l.final_line_price) + "</span>" +
              "</div>" +
            "</div>" +
          "</div>";
        }).join("");
      }
    }
    var qualifiesForFreeShipping = cart.items_subtotal_price >= FREE_SHIP;
    var cartHasItems = cart.item_count > 0;
    var estimatedShipping = cartHasItems && !qualifiesForFreeShipping ? ESTIMATED_SHIPPING : 0;
    setText("[data-cart-sub]", money(cart.items_subtotal_price));
    setText("[data-cart-total]", money(cart.total_price + estimatedShipping));
    setText("[data-cart-total-label]", cartHasItems && !qualifiesForFreeShipping ? "Estimated total" : "Total");
    var shippingEl = document.querySelector("[data-cart-shipping]");
    if (shippingEl) {
      shippingEl.textContent = !cartHasItems ? "—" : qualifiesForFreeShipping ? "FREE" : "Estimated " + money(ESTIMATED_SHIPPING);
      shippingEl.classList.toggle("is-free", qualifiesForFreeShipping);
    }

    var wasUnlocked = shippingUnlocked;
    shippingUnlocked = qualifiesForFreeShipping && cartHasItems;
    if (shippingUnlocked && !wasUnlocked) shippingCelebrationPending = true;
    if (!shippingUnlocked) shippingCelebrationPending = false;
    var reward = drawer && drawer.querySelector(".cart__ship");
    if (reward) {
      reward.classList.toggle("is-unlocked", shippingUnlocked);
      if (!shippingUnlocked) {
        clearTimeout(shippingCelebrationTimer);
        reward.classList.remove("is-celebrating");
      }
    }
    var pct = Math.min(100, Math.round((cart.items_subtotal_price / FREE_SHIP) * 100));
    var bar = document.querySelector("[data-ship-bar]"); if (bar) bar.style.width = pct + "%";
    var progress = document.querySelector("[data-ship-progress]");
    if (progress) progress.setAttribute("aria-valuenow", String(pct));
    var msg = document.querySelector("[data-ship-msg]");
    if (msg) {
      var sub = cart.items_subtotal_price;
      if (sub === 0) msg.innerHTML = "Spend <b>" + money(FREE_SHIP) + "</b> to unlock free US shipping";
      else if (shippingUnlocked) msg.textContent = "Free US shipping unlocked!";
      else msg.innerHTML = "You're <b>" + money(FREE_SHIP - sub) + "</b> away from free US shipping";
    }
    celebrateShipping();

    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle("show", cart.item_count > 0);
    });
  }

  function refresh() {
    return fetch(r("cart_url", "/cart") + ".js", { headers: { Accept: "application/json" } })
      .then(function (res) { return res.json(); })
      .then(render)
      .catch(function () {});
  }

  function add(variantId, qty) {
    return fetch(r("cart_add_url", "/cart/add"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function (res) {
      return res.json().then(function (payload) {
        if (!res.ok || payload.status) throw new Error(payload.description || "Unable to add this item.");
        return payload;
      });
    }).then(function () { return refresh(); }).then(openCart);
  }

  function change(key, qty) {
    return fetch(r("cart_change_url", "/cart/change"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (res) { return res.json(); }).then(render).catch(function () {});
  }

  function closeCardQuick(quick) {
    if (!quick) return;
    quick.classList.remove("is-sizing");
    var trigger = quick.querySelector("[data-card-quick-open]");
    var sizes = quick.querySelector("[data-card-quick-sizes]");
    if (trigger) trigger.setAttribute("aria-expanded", "false");
    if (sizes) sizes.hidden = true;
  }

  function closeOtherCardQuicks(except) {
    document.querySelectorAll("[data-card-quick].is-sizing").forEach(function (quick) {
      if (quick !== except) closeCardQuick(quick);
    });
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-cart-open]")) { e.preventDefault(); openCart(); refresh(); return; }
    if (e.target.closest("[data-cart-close]")) { closeCart(); return; }
    if (drawer && drawer.classList.contains("open") && e.target === drawer) { closeCart(); return; }
    var quickOpen = e.target.closest("[data-card-quick-open]");
    if (quickOpen) {
      e.preventDefault();
      var quick = quickOpen.closest("[data-card-quick]");
      if (!quick) return;
      closeOtherCardQuicks(quick);
      var sizes = quick.querySelector("[data-card-quick-sizes]");
      quick.classList.add("is-sizing");
      quickOpen.setAttribute("aria-expanded", "true");
      if (sizes) sizes.hidden = false;
      var firstSize = quick.querySelector("[data-add]:not([disabled])");
      if (firstSize) firstSize.focus();
      return;
    }
    var quickClose = e.target.closest("[data-card-quick-close]");
    if (quickClose) {
      e.preventDefault();
      var closingQuick = quickClose.closest("[data-card-quick]");
      closeCardQuick(closingQuick);
      var reopen = closingQuick && closingQuick.querySelector("[data-card-quick-open]");
      if (reopen) reopen.focus();
      return;
    }
    var addEl = e.target.closest("[data-add]");
    if (addEl) {
      e.preventDefault();
      var vid = addEl.getAttribute("data-add");
      if (!vid) return;
      var cardQuick = addEl.closest("[data-card-quick]");
      addEl.setAttribute("disabled", "disabled");
      add(vid, 1).then(function () {
        addEl.removeAttribute("disabled");
        closeCardQuick(cardQuick);
      }, function () { addEl.removeAttribute("disabled"); });
      return;
    }
    var q = e.target.closest("[data-qty]");
    if (q) { var parts = q.getAttribute("data-qty").split("|"); change(parts[0], parseInt(parts[1], 10)); return; }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    closeCart();
    closeOtherCardQuicks();
  });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", refresh);
  else refresh();
})();
